import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getInvoiceEmails } from 'modules/_common/api';

export const useQuerySendInvoiceToEmail = ({
  invoiceId,
  enabled,
}: {
  invoiceId: string;
  enabled: boolean;
}) => {
  return useQuery(
    [QUERY_KEYS.INVOICES_SEND_INVOICE_TO_EMAIL, invoiceId],
    () => getInvoiceEmails(invoiceId),
    {
      enabled,
    },
  );
};
